module.exports = __webpack_public_path__ + "static/media/product_id.62a1b18f.jpg";